/** 得点ロジック。企画書 5.1 に対応。 */
export const POINTS = {
    early: 300,
    mid: 200,
    late: 100,
    final: 50,
};
/** 誤答の減点の既定値（正の数）。0% で当てずっぽうに押す期待値が 0 になる値 */
export const DEFAULT_WRONG_PENALTY = 100;
export const TIER_EARLY_MAX = 33;
export const TIER_MID_MAX = 66;
export function tierFor(pct, finalMode) {
    if (finalMode)
        return 'final';
    if (pct <= TIER_EARLY_MAX)
        return 'early';
    if (pct <= TIER_MID_MAX)
        return 'mid';
    return 'late';
}
/** 早押し時点の完成率（0〜100）から正解時の得点を返す。 */
export function pointsForCorrect(pct, opts = {}) {
    const base = POINTS[tierFor(pct, opts.finalMode ?? false)];
    return opts.halved ? Math.round(base / 2) : base;
}
/** 誤答の得点（負の数）。penalty は設定値（正の数） */
export function pointsForWrong(penalty = DEFAULT_WRONG_PENALTY) {
    return -Math.abs(Math.round(penalty));
}
/** 正解者を押した順（描画経過時間 → サーバー受信時刻）に並べる */
export function sortCorrectByTime(outcomes) {
    return [...outcomes]
        .filter((o) => o.correct)
        .sort((a, b) => a.elapsedMs - b.elapsedMs || (a.at ?? 0) - (b.at ?? 0));
}
/** 通算順位: 総得点 → 正解数 → 名前 */
export function compareTotal(a, b) {
    return b.score - a.score || b.correct - a.correct || a.name.localeCompare(b.name);
}
/** 完成率（0〜100）を計算する。 */
export function completionPct(now, startAt, pausedTotalMs, pausedAt, durationMs) {
    const effectiveNow = pausedAt ?? now;
    const elapsed = effectiveNow - startAt - pausedTotalMs;
    if (durationMs <= 0)
        return 100;
    return Math.max(0, Math.min(100, Math.round((elapsed / durationMs) * 100)));
}
//# sourceMappingURL=scoring.js.map